/**
 * @file Contém as constantes do sistema
 */
const sistema = {
        sigla: 'SISTEMA',
        descricao: 'Sistema Básico',
}
export default sistema;
